import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { NgxErrorsModule } from '@hackages/ngxerrors';

import { ErrorComponent } from './components/error.component';

@NgModule({
    imports: [
        CommonModule,
        NgxErrorsModule,
    ],
    declarations: [
        ErrorComponent,
    ],
    exports: [
        ErrorComponent,
    ],
})

export class ErrorModule {}
